import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconChildTrackerProps } from './IconChildTracker.types'
import * as Styled from './styles/IconChildTracker.style'

import { nonThemeableRules } from '../../ruleSet'

const IconChildTracker: FC<IconChildTrackerProps> = ({
  size = nonThemeableRules.defaultSize as number as IconChildTrackerProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconChildTrackerProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M11.38 2.47c7.11 0 8.71 5.45 8.71 10.27a8.73 8.73 0 0 1-17.43.63v-.63c0-4.81 1.55-10.27 8.72-10.27Z'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <path
          d='M14.28 16.44a3.91 3.91 0 0 1-5.52.41 4.32 4.32 0 0 1-.43-.46m-4.98-7.7L22.8 6.37m-12.67-3.7a7.74 7.74 0 0 1 3.17 4.59'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <circle cx='14.43' cy='12.26' fill='none' r='.65' vectorEffect='non-scaling-stroke' />
        <circle cx='14.43' cy='12.26' fill='none' r='.16' vectorEffect='non-scaling-stroke' />
        <circle cx='8.63' cy='12.26' fill='none' r='.65' vectorEffect='non-scaling-stroke' />
        <circle cx='8.63' cy='12.26' fill='none' r='.16' vectorEffect='non-scaling-stroke' />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconChildTracker
